import { Injectable } from '@angular/core';

@Injectable()
export class NumberFormatService {

  public getFormatedNumber(num, maxFractionDigits: number, minFractionDigits: number = 0): string {
    num = num && this.shouldFormatNumber(num) ? this.formatDecimals(num, maxFractionDigits) : num;
    if (num && +num === 0) {
      // we add 2 characters for 0. at the beginning
      num = num.slice(0, maxFractionDigits + 2);
    }

    if (num && !isNaN(num) && this.shouldFormatNumber(num)) {
      // formatting the number using Javascript function - NumberFormat
      // en-US is type of formatting that fits our needs e.g. 1,000.00
      return new Intl.NumberFormat('en-US', {
        maximumFractionDigits: maxFractionDigits,
        minimumFractionDigits: minFractionDigits,
      })
        .format(num);
    }
    return num;
  }

  public formatNumberInput(event, maxFractionDigits: number, minFractionDigits: number = 0): void {
    let input = event.target.value;
    input = input.replace(/[^0-9.-]+/g, '');

    if (String(input).endsWith('.') && this.shouldFormatNumber(input)) {
      event.target.value = this.getFormatedNumber(input, maxFractionDigits, minFractionDigits) + '.';

      // if the value ends with a dot and there is already one in the value, remove the last character
      if (this.countDots(event.target.value) === 2 && String(event.target.value).endsWith('.')) {
        event.target.value = event.target.value.slice(0, -1);
      }

      return;
    }

    if (String(event.target.value).startsWith('-00')) {
      event.target.value = event.target.value.slice(0, -1);

      return;
    }
    event.target.value = this.getFormatedNumber(input, maxFractionDigits, minFractionDigits);
  }

  public getNumberOfCommasInString(value: string): number {
    const commasArray = (value).match(/\,/g);

    return commasArray ? commasArray.length : 0;
  }

  public removeCommaAndGetNumber(value, defaultValue: number): number {
    if (value && typeof value === 'number') {
      return value;
    }

    if (!value || (typeof value === 'object' && Object.keys(value).length === 0)) {
      return null;
    }
    const val = value === '-' || !this.shouldFormatNumber(value) ?
      value : Number(value.replace(/,/g, ''));

    return !isNaN(val) ? val : defaultValue;
  }

  public handleCursorPosition(
    event,
    element,
    value,
    maxFractionDigits: number,
    startsWithDotOrComma: boolean,
    startsWithMinus: boolean,
    minFractionDigits = 0
  ): string|number {
    if (String(event.target.value).endsWith('.0')) {
      return event.target.value;
    }
    // get cursor position in input without commas
    let cursor = element.selectionStart - this.getNumberOfCommasInString(event.target.value);
    // format input & insert commas
    this.formatNumberInput(event, maxFractionDigits, minFractionDigits);
    const numberOfCommas = this.getNumberOfCommasInString(event.target.value);
    // add number of commas to cursor position
    cursor += numberOfCommas;

    value = this.removeCommaAndGetNumber(
      event.target.value,
      value
    );

    const isElementOnTheLeftComma = event.target.value.slice(cursor - 1, cursor) === ',';
    setTimeout(() => {
      cursor = isElementOnTheLeftComma ? cursor - 1 : cursor;
      cursor = startsWithDotOrComma ? cursor + 1 : cursor;
      cursor = startsWithMinus ? cursor + 2 : cursor;

      // set cursor position to where it was
      element.setSelectionRange(cursor, cursor);
    }); // this prevents moving cursor to the end of input

    return value;
  }

  private formatDecimals(numberToFormat: string|number, maxFractionDigits): string|number {
    if (typeof numberToFormat === 'string') {
      // tslint:disable-next-line
      let [whole, fraction] = numberToFormat.split('.');

      return fraction ? Number(`${whole}.${fraction}`).toFixed(maxFractionDigits) : whole;
    }

    if (numberToFormat) {
      numberToFormat = Number(numberToFormat).toFixed(maxFractionDigits);
    }

    return numberToFormat || 0;
  }

  private shouldFormatNumber(num: string): boolean {
    // preventing 00 and -00 from being entered
    num = String(num).includes('-') ? String(num).substring(1) : num;

    return String(num).startsWith('00') || Number(num) !== -0;
  }

  private countDots(value = ''): number {
    const dotsArray = value.match(/\./g);

    return dotsArray ? dotsArray.length : 0;
  }
}
